import React from "react";

import Typography from "../@typography";
import { Button } from "./styles";

interface Props {
  size: "small" | "medium" | "large";
  textButton: string;
  icon?: React.ReactNode;
  backgroundColor?: string;
  background?: string;
  color: string;
  disabled?: boolean;
  onPress: Function;
}

const CustomButton: React.FC<Props> = ({
  textButton,
  size,
  icon,
  backgroundColor,
  background,
  color,
  disabled,
  onPress,
}) => {
  return (
    <Button
      onClick={() => onPress()}
      disabled={disabled || false}
      style={{ backgroundColor, color, background }}
      size={size}
      startIcon={icon}
    >
      <Typography
        fontSize={14}
        color={color}
        text={textButton}
        variant="body2"
      />
    </Button>
  );
};
export default CustomButton;
